/**
 * MagnetPostReels — Instagram Reels poszt-flow.
 *
 * Vékony wrapper a MagnetPostFacebook komponens fölött `platform="instagram_reels"`
 * propal. A Reels ügynök a Facebook Posztvarázsló REPLIKÁCIÓJA, a következő
 * Reels-specifikus változtatásokkal:
 * - Backend: Outline Generator a 8 Reels-szöget használja, a Writer a Reels
 *   Master System Promptot kapja (vulnerable expertise helyett vertikális
 *   videós, 2026-os IG algoritmus-optimalizált, 9-mezős strukturált output).
 * - Output: 9-mezős strukturált tartalomcsomag (Hook, Vizuális utasítás,
 *   Voiceover, Klipek, Hang, Leírás, Miért működik, A/B horogok).
 * - Mentés: agent_type="post-reels", forras_alkartya="instagram_reels".
 */
import MagnetPostFacebook from "./MagnetPostFacebook";

export default function MagnetPostReels(props) {
  return <MagnetPostFacebook {...props} platform="instagram_reels" />;
}
